import { Transaction } from "./types";
import * as SecureStore from "@towersystems/roam-common-native";
const STORAGE_KEY = "tower_payments_session";

export type CachedTowerPaymentsSession = {
  saleId: string;
  transaction: Transaction;
};
export const saveTowerPaymentsSession = async ({
  saleId,
  transaction,
}: {
  saleId: string;
  transaction: Transaction;
}): Promise<void> => {
  const session: CachedTowerPaymentsSession = {
    saleId,
    transaction,
  };
  await SecureStore.storeItemAsync(STORAGE_KEY, JSON.stringify(session));
  return;
};

export const retrieveTowerPaymentSession = async ({
  saleId,
}: {
  saleId: string;
}): Promise<Transaction | undefined> => {
  const data = await SecureStore.getItemAsync(STORAGE_KEY);
  if (data) {
    const session: CachedTowerPaymentsSession = JSON.parse(data);
    if (session.saleId === saleId) {
      return session.transaction;
    }
  }
  return undefined;
};

export const clearTowerPaymentsSession = async () => {
  await SecureStore.deleteItemAsync(STORAGE_KEY);
  return;
};
